/**
 * This module is in charge of controlling switch visual components.
 */
(function() {

    "use strict";
    var DEFAULT_CONFIG = {
        position: 'RIGHT_BOTTOM',

    };
    var ID = 0;

    define('fg-arv/components/legend',['fg-arv/libs/mustache'], function(Mustache) {
        var _styles;
        var module = {
            createComponent: function(config) {
                var container = document.createElement('div');
                container.className = 'fg-arv_legend-component';
                if (container) {
                    var id = createDomID();
                    var conf = jQuery.extend({
                        id: id
                    }, DEFAULT_CONFIG, config);

                    var map = conf.widget.getMap();
                    var controls = map.controls[google.maps.ControlPosition[conf.position]].getArray();
                    if (jQuery.inArray(container, controls) !== -1) {
                        container = controls[jQuery.inArray(container, controls)];
                    } else {
                        jQuery(container).addClass('map-control');
                        container.index = 3;
                        map.controls[google.maps.ControlPosition[conf.position]].push(container);
                    }

                    var template = createTemplate(conf);
                    container.innerHTML = template;

                    var component = {
                        getID: function() {
                            return id;
                        },
                        init: function(styles) {
                            var componentElement = jQuery('#' + id);
                            _styles = styles;
                            var legendContent = "<table>";
                            for (var item in styles) {
                                var text = styles[item].text ? styles[item].text : item;
                                legendContent += "<tr><td>" + createLineLegend(styles[item]) + "</td><td>" + text.toUpperCase() + "</td></tr>";
                            }
                            legendContent += "</table>";
                            componentElement.html(legendContent);
                        }

                    };

                    return component;
                }
            },
            getStyles: function() {
                return _styles;
            }
        };

        return module;

        //*********************************************************

        function createTemplate(config) {
            return "<div id='" + config.id + "' class='legend'>" +
                "</div>";
        }

        function createDomID() {
            var i = ++ID;
            return "fg-arv-legend-" + i;
        }

        function createLineLegend(style) {
            var rules = {
                width: '30px',
                height: style.strokeWeight ? style.strokeWeight + 'px' : '5px',
                backgroundColor: style.strokeColor ? style.strokeColor : style.icons[0].icon.fillColor ? style.icons[0].icon.fillColor : 'black'
            };
            if (style.icons) {
                var path = style.icons[0].icon.path;
                rules.backgroundImage = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='30'><path d='" + path + "' style='stroke:" + rules.backgroundColor + "; stroke-width:15;' /></svg>";
                if (path === 0) {
                    rules.backgroundImage = "http://upload.wikimedia.org/wikipedia/commons/d/d4/WX_circle_lightblue.png";
                    rules.backgroundPosition = "50% 50%";
                    rules.backgroundSize = "5px 5px";
                }
            }
            var template = "<div style='width:{{width}};height:{{height}};{{#backgroundColor}}{{^backgroundImage}}background-color:{{backgroundColor}};" +
                "{{/backgroundImage}}{{/backgroundColor}}{{#backgroundImage}}background:url(\"{{backgroundImage}} \"){{/backgroundImage}} repeat-x; {{#backgroundPosition}}background-position:{{backgroundPosition}}{{/backgroundPosition}};{{#backgroundSize}}background-size:{{backgroundSize}}{{/backgroundSize}};'>" +
                "</div > ";
            return Mustache.render(template, rules);
        }

    });

})();

